import DeleteIcon from '@mui/icons-material/Delete';
import CalendarDatePicker from '@/trio-ui/CalendarDatePicker';
import * as Styles from './CandidateFilter.styles';
import CandidateFilterAutoComplete, { AutoCompleteTypes } from '../CandidateFilterAutocomplete';
import CandidateFilterBoxText, { CandidateFilterBoxTextTypes } from '../CandidateFilterBoxText';
import CandidateSearchForFilter from '../CandidateSearchForFilter';

export type CandidateFilterProps = AutoCompleteTypes &
  CandidateFilterBoxTextTypes & {
    onRemoveFilterHandler: () => void;
    onClickValue: () => void;
    searchForCandidates: boolean;
    onSelectDate: (startDate: Date, endDate?: null | Date) => void;
    isDateType: boolean;
  };

const CandidateFilterComponent = ({
  filter,
  onRemoveFilterOption,
  onRemoveFilterHandler,
  onSelectFilterOption,
  searchForCandidates,
  isDateRange,
  isDatePicker,
  withSearch,
  options,
  onOptionsClick,
  onSelectDate,
  selectedOptions,
  groupedOptions,
  isDateType,
  valueElement,
  conditionElement,
  onClickCondition,
  onClickValue,
  ...props
}: CandidateFilterProps): JSX.Element => {
  const { isOpened, showingDeleteButton, value, condition, field } = filter;
  const showDatePicker = isOpened && isDateType && !searchForCandidates;
  const showCandidateAutocomplete = searchForCandidates && isOpened;
  const showAutocompleteDropdown = !searchForCandidates && isOpened && !isDateType;
  const formattedField = filter?.field?.toString().toLowerCase().replace(/\s/g, '');
  const isFilterApplied = (field && condition && value) || (field && condition.includes('Empty'));

  return (
    <Styles.Box
      {...props}
      isOpen={isOpened}
      withHigherIndex={filter.showingDeleteButton || isOpened}
      onClick={(event) => {
        event.stopPropagation();
        if (!isOpened) {
          onClickValue();
        }
      }}
      isDisabled={!isFilterApplied && !isOpened}
    >
      <CandidateFilterBoxText
        onClickCondition={onClickCondition}
        valueElement={valueElement}
        conditionElement={conditionElement}
        filter={filter}
        isDateRange={isDateRange}
        isDatePicker={isDatePicker}
        onOptionsClick={onOptionsClick}
      />

      {showAutocompleteDropdown && (
        <CandidateFilterAutoComplete
          onRemoveFilterOption={onRemoveFilterOption}
          withSearch={withSearch}
          selectedOptions={selectedOptions}
          options={options}
          groupedOptions={groupedOptions}
          onSelectFilterOption={onSelectFilterOption}
        />
      )}

      {showDatePicker && (
        <CalendarDatePicker isDateRange={isDateRange} onSelectDate={onSelectDate} />
      )}

      {showCandidateAutocomplete && (
        <CandidateSearchForFilter onSelectFilterOption={onSelectFilterOption} />
      )}
      {showingDeleteButton && (
        <Styles.DeleteButton
          size="sm"
          onClick={(e) => {
            e.stopPropagation();
            onRemoveFilterHandler();
          }}
          colorScheme="gray"
          data-testid={`remove-candidate-filter-${formattedField}-btn`}
          leftIcon={<DeleteIcon />}
          fontWeight="lighten"
          aria-label="Remove Filter"
          type="button"
        >
          Delete
        </Styles.DeleteButton>
      )}
    </Styles.Box>
  );
};

export default CandidateFilterComponent;
